import * as React from "react"
import { SVGProps } from "react"
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Livello_2"
    width={48}
    height={48}
    data-name="Livello 2"
    {...props}
  >
    <defs>
      <style>
        {
          ".cls-25{fill:none;stroke:#00a4b7;stroke-miterlimit:10;stroke-width:2px}"
        }
      </style>
    </defs>
    <g id="Palette">
      <circle
        cx={24}
        cy={24}
        r={24}
        style={{
          fill: "#060b0c",
          strokeWidth: 0,
        }}
      />
      <path d="M12 16h24M12 24h24M12 32h24" className="cls-25" />
    </g>
  </svg>
)
export default SvgComponent
